import React from 'react';
import MetaControlField from 'Components/UI/Meta/MetaForm/Components/MetaControlField';
import { PXPicklistQuestionModalWrapper } from 'Views/Page/Content/Modal/Layouts/PXPicklistQuestionModalWrapper';
import { dataAttrs } from 'Helpers/Testing';

const Layout = () => {
  return (
    <PXPicklistQuestionModalWrapper>
      <MetaControlField attr={'description'} />
      <MetaControlField attr={'whyDidYouJoin'} {...dataAttrs('why-did-you-join-question')} />
    </PXPicklistQuestionModalWrapper>
  );
};

export default Layout;
